import { Button } from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * "Volver" que respeta la pila de navegación: retrocede a la vista anterior, sea
 * cual sea. A una ficha se llega desde muchos lados —Procesos, Estudiantes, el
 * catálogo— y mandar siempre a la misma sección pierde el camino recorrido.
 *
 * Si la ficha se abrió directa (un link compartido, un F5) no hay pila que
 * deshacer: entonces va a `fallback`, y la etiqueta nombra ese destino en vez de
 * decir "Volver". React Router marca esa primera entrada con `key === "default"`.
 */
export default function BotonVolver({
  fallback,
  etiquetaFallback,
}: {
  /** Dónde ir cuando no hay vista anterior (entrada directa a la URL). */
  fallback: string;
  /** Texto en ese caso; por omisión, "Volver". */
  etiquetaFallback?: string;
}) {
  const navigate = useNavigate();
  const { key } = useLocation();
  const hayPila = key !== "default";

  return (
    <Button startIcon={<ArrowBackIcon />} onClick={() => (hayPila ? navigate(-1) : navigate(fallback))} sx={{ mb: 2, ml: -1 }}>
      {hayPila ? "Volver" : etiquetaFallback ?? "Volver"}
    </Button>
  );
}
